import React from 'react';
import { format } from 'date-fns';

export const TABLE_COLUMNS = [
  {
    Header: 'S.No',
    accessor: (row, index) => index + 1,
    disableFilters: true,
  },
  {
    Header: 'Participant Name',
    accessor: 'participant_name',
    disableFilters: false,
  },
  {
    Header: 'Participant Email',
    accessor: 'participant_email',
    disableFilters: false,
  },
  {
    Header: 'Award Type',
    accessor: 'award_type',
    disableFilters: false,
  },
  {
    Header: 'Award Amount',
    accessor: 'award_amount',
    disableFilters: true,
    Cell: ({ value }) => (
      <span>
        {value ? new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(value) : '-'}
      </span>
    ),
  },
  {
    Header: 'Awarded Date',
    accessor: 'awarded_date',
    disableFilters: true,
    Cell: ({ value }) => (
      <span>
        {value ? format(new Date(value), 'MM/dd/yyyy') : '-'}
      </span>
    ),
  },
  {
    Header: 'Award Expiry Date',
    accessor: 'expiry_date',
    disableFilters: true,
    Cell: ({ value }) => (
      <span>
        {value ? format(new Date(value), 'MM/dd/yyyy') : '-'}
      </span>
    ),
  }
];